import Vue from 'vue'

// https://bootstrap-vue.js.org/docs/
// https://developer.okta.com/blog/2018/02/15/build-crud-app-vuejs-node
import { BootstrapVue, IconsPlugin, BPopover } from 'bootstrap-vue'
import 'bootstrap/dist/css/bootstrap.css'
import 'bootstrap-vue/dist/bootstrap-vue.css'

import { library } from '@fortawesome/fontawesome-svg-core'
import { faUserSecret, faKey, faMask, faCat, faAngry, faBell } from '@fortawesome/free-solid-svg-icons'
import { FontAwesomeIcon } from '@fortawesome/vue-fontawesome'

Vue.use(BootstrapVue)
// Optionally install the BootstrapVue icon components plugin
Vue.use(IconsPlugin)

Vue.component('b-popover', BPopover)

// https://github.com/FortAwesome/vue-fontawesome
// add the "solid" icons to the core library
library.add(faUserSecret, faKey, faMask, faCat, faAngry, faBell)
Vue.component('font-awesome-icon', FontAwesomeIcon)



// WEBPACK FOOTER //
// ./src/plugins/bootstrap-vue.js